module.exports = __webpack_public_path__ + "img/1966463.jpg";